
import { getLinkListByMobile,modifyTeacherDistStatus,distLinkListData,queryDistMobilePage,saveTeacherDist,queryTeacherDist,queryTeacherDistPage,addToTeacherDistList} from '@/zsm-api-new/dist.js'
const state = {

}

const mutations = {

}

const actions = {
  /**
 * 通过达人手机号查询达人下关联的抖音列表
 * @param mobile 手机号
 */
  getLinkListByMobile({ commit }, data) {
    return new Promise((resolve, reject) => {
      getLinkListByMobile(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 修改达人状态
   * @param id 编号
   * @param distStatus 1.正常 2.禁用
   */
  modifyTeacherDistStatus({ commit }, data) {
    return new Promise((resolve, reject) => {
      modifyTeacherDistStatus(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查询讲师关联的单个达人信息
   * @param id 绑定的id
   */
  queryTeacherDist({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryTeacherDist(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查询讲师关联的绑定达人
   * @param teacherMobile 老师埃手机号
   * @param distHead 达人头像
   * @param distMobile 达人手机号
   * @param distHead 达人头像
   * @param distNick 达人昵称
   * @param distName 达人姓名
   * @param distRatio 达人分销比例
   * @param distWxld 1.定向达人2普通达人
   * @param goodIdList 关联商品id集合
   * @param  pageNo 当前页数
   * @param  pageSize 每页条数
   */
  queryTeacherDistPage({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryTeacherDistPage(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
   * 绑定现销达人
   * @param teacherMobile 老师埃手机号
   * @param distHead 达人头像
   * @param distMobile 达人手机号
   * @param distHead 达人头像
   * @param distNick 达人昵称
   * @param distName 达人姓名
   * @param distRatio 达人分销比例
   * @param distWxld 1.定向达人2普通达人
   * @param goodIdList 关联商品id集合
   */
  addToTeacherDistList({ commit }, data) {
    return new Promise((resolve, reject) => {
      addToTeacherDistList(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },


  /**
   * 讲师绑定达人
   * @param teacherMobile 老师埃手机号
   * @param distHead 达人头像
   * @param distMobile 达人手机号
   * @param distHead 达人头像
   * @param distNick 达人昵称
   * @param distName 达人姓名
   * @param distRatio 达人分销比例
   * @param distWxld 1.定向达人2普通达人
   * @param goodIdList 关联商品id集合
   */
  saveTeacherDist({ commit }, data) {
    return new Promise((resolve, reject) => {
      saveTeacherDist(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 查询所有达人列表
   * @param pageNo 达人的微信id
   * @param pageSize 页数
   */
  queryDistMobilePage({ commit }, data) {
    return new Promise((resolve, reject) => {
      queryDistMobilePage(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  /**
   * 通过微信openid获取绑定的抖音列表
   * @param weixinId 达人的微信id
   */
  distLinkListData({ commit }, frontId) {
    return new Promise((resolve, reject) => {
      distLinkListData(frontId).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
